import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface IProps extends Omit<IAutoCompleteProps, 'onGetSuggestions' | 'onChange'> {
    onChange: (items: AutoCompleteDataModel[]) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de locais de trabalho
 * @param props
 */
export const WorkplaceAutoComplete: React.FC<IProps> = ({ onChange, onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.workplaces({
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
            .then(result => resolve({
                items: result.data.items as AutoCompleteDataModel[],
                totalRows: result.data.totalRows
            }))
            .catch(e => {
                if (!isCanceledError(e)) {
                    resolve({ items: [], totalRows: 0 });
                    if (onError) onError(e);
                }
            });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onError={onError}
            onGetSuggestions={getSuggestions}
            onChange={onChange}
        />
    );
};
